// Stable data-testid values for the P5-C admin screens (the QA worker's e2e contract).
export const CTID = {
  ordersPage: "page-orders",
  orderRow: (number: string) => `order-row-${number}`,
  orderSearch: "orders-search",
  newOrder: "orders-new",
  orderViews: "orders-views",
  orderDetail: "page-order-detail",
  orderMove: (to: string) => `order-move-${to}`,
  orderMarkPaid: "order-mark-paid",
  orderStatusSelect: "order-status-select",
  orderBook: "order-book-courier",
  paymentsPage: "page-payments",
  paymentsTabs: "payments-tabs",
  queueItem: (id: string) => `verify-item-${id}`,
  verify: (id: string) => `verify-${id}`,
  reject: (id: string) => `reject-${id}`,
  methodSwitch: (p: string) => `method-${p}`,
  addQrAccount: "add-qr-account",
  customersPage: "page-customers",
  customerDetail: "page-customer-detail",
  couponsPage: "page-coupons",
  couponCreate: "coupon-create",
  taxPage: "page-taxes",
  kpis: "commerce-kpis",
  kpiOrders: "kpi-orders",
  kpiSales: "kpi-sales",
} as const;
